import React from 'react';
import postal from 'postal';
import breakpoints from '../../shared/breakpoints';

export default class StyleGuideLivewirePasswordModal extends React.Component {
  componentDidMount() {
    postal.subscribe({
      channel: 'commands.style-guide-livewire-password-modal',
      topic: 'present',
      callback: () => this.present(),
    });
  }

  present() {
    breakpoints.upFrom_medium() && this.$overlay.fadeIn(400);
    this.$modal.fadeIn(400);
  }

  dismiss() {
    breakpoints.upFrom_medium() && this.$overlay.fadeOut(400);
    this.$modal.fadeOut(400);
  }

  render() {
    return (
      <div>
        <div
          role="region"
          ref={el => (this.$overlay = $(el))}
          className="livewire-modal-overlay style-guide-livewire-password-modal-overlay"
          onClick={() => this.dismiss()}
        />
        <div
          ref={el => (this.$modal = $(el))}
          className="livewire-modal style-guide-livewire-password-modal"
          tabIndex="-1"
          role="dialog"
        >
          <article>
            <header>
              <button type="button" className="close-modal" onClick={() => this.dismiss()}>
                <span className="pe-7s-close pe-icon-x3" />
                <span className="sr-only">Close</span>
              </button>
              <h4>Provide your password</h4>
            </header>
            <section>
              <p className="step-instructions">
                Enter a password for your new account. It must be at least 8 characters long.
              </p>
              <form onSubmit={() => this.dismiss()}>
                <div className="livewire-modal-form-container">
                  <p className="form-group">
                    <input type="password" placeholder="Password" />
                    <span className="help-block">Password is incorrect length</span>
                  </p>
                  <p className="form-group has-error">
                    <input type="password" placeholder="Verify password" />
                  </p>
                </div>
                <p className="has-error">
                  <span className="help-block">You must provide a password for your account</span>
                </p>
                <p className="form-group">
                  <button type="submit" className="btn btn-primary">Continue</button>
                </p>
              </form>
            </section>
          </article>
        </div>
      </div>
    );
  }
}
